import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");
const lowcost = require("../../../assets/icons-pack/4.2 Volume Backup Service/ic_03_lowcost.svg");
const disasterrecovery = require("../../../assets/icons-pack/3.1 Elastic Computer Server/ic_05_disasterrecovery.svg");

const AntiDDOS = () => {
    const heading = `ANTI-DDOS`;
    const details = `Protect your Cloud from DDoS attacks using state-of-the-art Anti-DDoS mechanisms.`;

    const overview = [
        `DETASAD’s Anti-DDoS (Distributed Denial of Service) is a cloud-based service which proactively monitors customer’s traffic patterns and provides 24/7 remote management, auto detection, and risk mitigation against DDoS attacks from world-class scrubbing centers. DETASAD’s Anti-DDoS Technology Partner has developed a new model for rapid DDoS Mitigation through the automatic analysis of DDoS alerts and deployment of routing commands to ensure immediate action is taken when legitimate DDoS attacks are detected.`,
        `DETASAD Anti-DDoS is a mandatory service that gets automatically enabled once a Public IP is assigned to an instance. It assures that DETASAD Cloud services don’t give any room to compromise your environment’s security.`
    ];

    const advantages = [
        [
            `Risk-free Operations`,
            `Focus on your main business and be shielded from day-to-day infrastructure concerns and risks.`,
            icon
        ],
        [`No Wait Time`, `Start immediately rather than build and manage your own solution.`, disasterrecovery],
        [`Reliable`, `Service reliability and attack mitigation are included within the solution.`, icon],
        [
            `Cost Effective`,
            `Customers can implement a robust Anti-DDoS service without investing in expensive hardware or professional services.`,
            lowcost
        ]
    ];

    const functions = [
        [
            `Fully-equipped Mechanism`,
            [`Provides anomaly detection, packet scrubbing, traffic analysis, and trap alerts.`]
        ],
        [
            `Activity Tracking`,
            [`For your specific Public IP, the details of the anomalies can be provided upon request.`]
        ],
        [`Ready for Deployment`, [`Rapid deployment and ease of management.`]]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-security"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default AntiDDOS;
